module.exports = __webpack_public_path__ + "media/images/pic/teachers/magdalena-zak-b570aa208c4d8aa48899fc949ce8417e.png";